import { render, staticRenderFns } from "./Major.vue?vue&type=template&id=f510cc9e&"
import script from "./Major.vue?vue&type=script&lang=js&"
export * from "./Major.vue?vue&type=script&lang=js&"
import style0 from "./Major.vue?vue&type=style&index=0&id=f510cc9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports